// Added by sephora-jsx-loader.js
var React = require('react');
// Added by sephora-jsx-loader.js
var Application = require('utils/framework/Application').default; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
var wrapComponentRenderModule = require('utils/framework/wrapComponentRender').default; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
var createClass = require('create-react-class')

// Added by sephora-jsx-loader.js
var wrapComponentRender = wrapComponentRenderModule().wrapComponentRender; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
/* eslint-disable max-len */
// Added by sephora-jsx-loader.js
var TextReplaceClass;// Added by sephora-jsx-loader.js
/* eslint-enable max-len */
const Markdown = require('components/Markdown/Markdown').default;
const PLACEHOLDER_RE = /{([^]*?}?)}/;

const getComponent = function (processElement, vars) {
    return (element, index) => <React.Fragment key={index}>{index % 2 ? vars[parseInt(element)] : processElement(element, index)}</React.Fragment>;
};
//TODO: make TextReplace a functional component
const TextReplace = function () {};

TextReplace.prototype.render = function () {
    const { content, isMarkdown, vars } = this.props;
    //This approach is more effective since it reduces nesting conditions while iterating elements
    const processElement = isMarkdown ? element => <Markdown content={element} /> : element => element;

    return <React.Fragment>{content.split(PLACEHOLDER_RE).map(getComponent(processElement, vars))}</React.Fragment>;
};

// Added by sephora-jsx-loader.js
Application.components.setByName('TextReplace', TextReplace); 
// Added by sephora-jsx-loader.js
/* eslint-disable max-len */
// Added by sephora-jsx-loader.js
TextReplace.prototype.class = TextReplace.prototype.displayName = 'TextReplace';
// Added by sephora-jsx-loader.js
TextReplace.prototype.render = wrapComponentRender(TextReplace);
// Added by sephora-jsx-loader.js
// .jsx// Added by sephora-jsx-loader.js

TextReplace.prototype.getInitialState = function() {
    TextReplace.apply(this, this.props.constructorArgs);
    return this.state;
};
TextReplace.prototype.originClass = TextReplace;
TextReplaceClass = createClass(TextReplace.prototype);
TextReplaceClass.prototype.classRef = TextReplaceClass;
Object.assign(TextReplaceClass, TextReplace);
TextReplaceClass.isComponent = true;
module.exports = TextReplaceClass;
// Added by sephora-jsx-loader.js
/* eslint-enable max-len */
// Added by sephora-jsx-loader.js

